import { render, staticRenderFns } from "./MailchimpIntegration.vue?vue&type=template&id=09079240&"
import script from "./MailchimpIntegration.vue?vue&type=script&lang=js&"
export * from "./MailchimpIntegration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports